var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitationStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5.8335H10.8334V7.50016H18.3334V5.8335Z",
    fill: "#42526E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 12.5002H10.8334V14.1668H18.3334V12.5002Z",
    fill: "#42526E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.16683H13.3334V10.8335H18.3334V9.16683Z",
    fill: "#42526E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.0002L6.66669 5.8335V9.16683H1.66669V10.8335H6.66669V14.1668L10.8334 10.0002Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationStatus);
export default __webpack_public_path__ + "static/media/invitation_status.dd03cd5b26c66d935877ee16c20384ce.svg";
export { ForwardRef as ReactComponent };